// extracted by mini-css-extract-plugin
export default {"fullContent":"store_fullContent__v7Lrt","storeList":"store_storeList__aSRmZ","storeTitleAndSubtitle":"store_storeTitleAndSubtitle__VgqqC","storeCart":"store_storeCart__XSYhM"};